import infrastructureApi from "./InfrastructureApi";

export async function getUserSessions(
    userId
) {
    const { data } =
        await infrastructureApi.get(
            `/sessions/${userId}`
        );

    return data;
}

export async function deleteUserSession(
    sessionId
) {
    const { data } =
        await infrastructureApi.delete(
            `/sessions/${sessionId}`
        );

    return data;
}

export async function revokeAllSessions(
    userId
) {
    const { data } =
        await infrastructureApi.delete(
            `/sessions/revokeAll/${userId}`
        );

    return data;
}

export async function verifyNewDevice(
    token
) {
    try {
        const { data } =
            await infrastructureApi.get(
                "/sessions/verify",
                {
                    params: {
                        token,
                    },
                }
            );

        return data;
    } catch {
        return {
            success: false,
            message:
                "expired_or_invalid",
        };
    }
}